import Model from '@/models/Model'

export default class PosCashDesk extends Model {

  resource() {
    return 'pos_cash_desk'
  }

  toCreate() {
    return this.clean([
      "g_branch_office_id",
      "name",
      "number",
    ])
  }

  toUpdate() {
    return this.clean([
      "id",
      "g_branch_office_id",
      "name",
      "number",
    ])
  }
}